import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs-compat';

@Component({
  selector: 'app-illustrator-body-card',
  templateUrl: './illustrator-body-card.component.html',
  styleUrls: ['./illustrator-body-card.component.css']
})

export class IllustratorBodyCardComponent implements OnInit, OnChanges  {
  //@ViewChild('annualEl') annualEl: ElementRef;
  @Input() value: number;
  @Input() futureValue: number;
  @Input() type: string;
  @Input() isSelected: boolean;
  @Input() dropDownValue: number = 10;
  @Input() oneTimeInvestment: number;
  @Input() lumpsum: number;
  @Input() phaseOnePercent: number = 6.00;
  @Input() illustrationType: string = "SS";
  @Input() object: any;
  @Input() dropDownSelectedIndex: number = 10;
  @Input() ignoreReloadOfComponent: boolean = false;
  @Output() adjustStartInvestment = new EventEmitter<any>();

  label: string;
  forLabel: string;
  isoneTimeInvestmentSelected: boolean;
  selectedIndex = (this.illustrationType == "SS") ? this.dropDownValue : this.dropDownSelectedIndex;
  origPassedValue: number;
  passedInitialLoad: boolean = false;

  constructor() {
    this.adjustStartInvestment = new EventEmitter();
  }

  ngOnInit() {
    console.log('the value', this.value);
    console.log('dropDownValue', this.dropDownValue);

    //this.dropDownSelectedIndex = (this.dropDownSelectedIndex) ? this.dropDownSelectedIndex : this.dropDownValue - 1;
    this.selectedIndex = (this.illustrationType == "SS") ? this.dropDownValue : this.dropDownSelectedIndex;
    this.origPassedValue = this.value;
    // let dropDownSelectedIndex = this.dropDownSelectedIndexAnnually ? this.dropDownSelectedIndexAnnually :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
    console.log('this.dropDownValue', this.dropDownValue);
    console.log('this.selectedIndex', this.selectedIndex);
    if (this.illustrationType != "SS") {
      this.selectedIndex = this.selectedIndex == 3 ? this.selectedIndex : (this.dropDownValue >= 10 ? 10 : 1);
    } else {
      //SS here
      //this.selectedIndex = (this.selectedIndex == 0) ? this.dropDownValue : this.selectedIndex;
    }

    // if retired default 3, if less than 5years default 1, otherwise 10
    this.setCardVerbiage(this.selectedIndex);

  }

  prevSelectedIndex;
  ngOnChanges(changes: SimpleChanges) {
    console.log('funding dropdown changes', changes);
    console.log('selectedIndex', this.selectedIndex);
    //this.prevSelectedIndex = 8;//(this.selectedIndex == this.prevSelectedIndex) ? this.prevSelectedIndex : this.selectedIndex;
    //this.selectedIndex = (this.illustrationType == "SS") ? this.dropDownValue : this.dropDownSelectedIndex;
    if(!this.ignoreReloadOfComponent){
      console.log('in here twice');
      this.selectedIndex = (this.illustrationType == "SS") ? this.dropDownValue : this.dropDownSelectedIndex;
      //this.dropDownSelectedIndex = (this.dropDownSelectedIndex) ? this.dropDownSelectedIndex : this.dropDownValue - 1;
      //this.selectedIndex = this.dropDownSelectedIndex;
      this.setCardVerbiage(this.selectedIndex);

      this.ignoreReloadOfComponent = true;
    } else {
      //this.selectedIndex = this.dropDownSelectedIndex;
      if(changes.dropDownSelectedIndex){
        this.selectedIndex = changes.dropDownSelectedIndex.currentValue;
        this.prevSelectedIndex = changes.dropDownSelectedIndex.currentValue;
        //this.setCardVerbiage(this.selectedIndex);
      } /* else if (this.prevSelectedIndex){
        console.log('resetting index to prev', this.prevSelectedIndex);
        this.selectedIndex = this.prevSelectedIndex;
        this.setCardVerbiage(this.selectedIndex);
      } */
    }
  }
  
  setCardVerbiage(selectedIndex) {
    if (this.type == 'oneTimeInvestment') {
      this.label = 'Make a One-Time <br> Investment of';
    } else {
      this.label = 'Make a Recurring <br> Investment of';
      if (this.type == 'annuallyRecurringInvestment') {
        this.label = 'Make a Recurring <br> Annual Investment of';
        // console.log('annuallyRecurringInvestment');
        // console.log(this.value);
        // console.log(selectedIndex);
        //if (selectedIndex != 0) {
          this.futureValue = this.calcPayments(this.lumpsum, this.origPassedValue, selectedIndex, this.phaseOnePercent, 1);//this.value * selectedIndex;
        //}

        // console.log('annuallyRecurringInvestment', this.futureValue);
        this.forLabel = 'Annually';
      } else if (this.type == 'weeklyRecurringInvestment') {
        this.label = 'Make a Recurring <br> Weekly Investment of';
        //if (selectedIndex != 0) {
          this.futureValue = this.calcPayments(this.lumpsum, this.origPassedValue, selectedIndex, this.phaseOnePercent, 52);//this.value * 52 * selectedIndex;
        //}
        this.forLabel = 'Weekly'; 
      }

    }

    this.passedInitialLoad = true;
  }

  onSelect() {
    if (this.type)
    this.isoneTimeInvestmentSelected = true;
  }

  calcWeeklySavings(event) {
    console.log('selected index from dropdown', event.target["selectedIndex"]);
    this.selectedIndex = event.target["selectedIndex"] + 1;
    this.setCardVerbiage(this.selectedIndex);
    
  }

  //freqFactor = 1 or 52
  calcPayments(lumpsum, beginningBalance, paymentYears, phaseOnePercent, freqFactor){
   /*  console.log('lumpsum', lumpsum);
    console.log('beginningBalance', beginningBalance);
    console.log('paymentYears', paymentYears);
    console.log('phaseOnePercent', phaseOnePercent);
    console.log('freqFactor', freqFactor); */

    phaseOnePercent = 0.01 * phaseOnePercent;
    //paymentYears = paymentYears - 1;
    var payment = Math.round(lumpsum / paymentYears);

    if(phaseOnePercent > 0){
      if(this.illustrationType == "SS"){
        //removed for now per a conversation I had with Dustin on calculating this...
        //var pay = Math.ceil(Math.abs(lumpsum * (phaseOnePercent / freqFactor) / (Math.pow(1 + (phaseOnePercent / freqFactor), (paymentYears * freqFactor + 1))) - (1 + phaseOnePercent / freqFactor)));
        //payment = (pay + beginningBalance) * ((freqFactor > 1) ? paymentYears * 52 : paymentYears);

        //NOTE: the below was done specifically for SS - if this needs to change for HC and/or LTC we will need to know what illustration this is beign called for      
        /* if(freqFactor == 1){ //annual 
          //= P16 * $B$1  /  ( (1+$B$1) ^ (B16 - B3) - 1 )
          var pay = Math.ceil(Math.abs(lumpsum * phaseOnePercent / (Math.pow((1 + phaseOnePercent), paymentYears) - 1)));
          payment = pay * paymentYears;//(pay + beginningBalance) * paymentYears;
        } else { //weekly        
          //= P16 * ($B$1/52)  /  ( (1+$B$1/52) ^ ( (B16 - B3) * 52 ) - 1 )
          var pay = Math.ceil(Math.abs(lumpsum * (phaseOnePercent / freqFactor) / (Math.pow(1 + phaseOnePercent / freqFactor, (paymentYears * freqFactor)) - 1)));
          payment = pay * (paymentYears * 52);//(pay + beginningBalance) * (paymentYears * 52);
        } */

        beginningBalance = lumpsum;//(this.illustrationType == "LTC") ? (this.object[paymentYears - 1].series.length > 1 ?(this.object[paymentYears - 1].series[0].name == 'Annual Healthcare Spend' ? this.object[paymentYears - 1].series[1].value : this.object[paymentYears - 1].series[0].value)  :this.object[paymentYears - 1].series[0].value): this.object[paymentYears].BeginningBalance.toFixed(0);
        console.log('beginningBalance', beginningBalance)
        console.log('phaseOnePercent', phaseOnePercent);
        console.log('freqFactor', freqFactor);
        //beginningBalanceB = beginningBalanceB / Math.pow((1 + (phaseOnePercent)), (this.dropDownValue - (paymentYears)));
        console.log('beginningBalance2', beginningBalance)
        console.log('payment years', paymentYears)

        //payment = pay * paymentYears;// * ((freqFactor > 1) ? paymentYears * 52 : paymentYears);
        var pay = Math.ceil(Math.abs(beginningBalance * (phaseOnePercent / freqFactor) / 
          ((Math.pow(1 + (phaseOnePercent / freqFactor), (paymentYears * freqFactor + 1))) - (1 + phaseOnePercent / freqFactor))));
        console.log('pay', pay);

        payment = pay * ((freqFactor > 1) ? paymentYears * 52 : paymentYears);
        //this.value = pay;//payment / paymentYears;
        console.log('payment', payment)
        if(this.passedInitialLoad){
          this.value = pay;//beginningBalance + pay;
          //console.log('payment', pay);
        }

        this.passedInitialLoad = true;
      } else {
        //all other illustrations here
        console.log('object passed to body card - Funding', this.object);
        console.log('paymentYears', paymentYears);
        // beginningBalance = (this.illustrationType == "LTC") ? this.object[paymentYears - 1].series[0].value : this.object[paymentYears - 1].BeginningBalance;
        beginningBalance = (this.illustrationType == "LTC") ? (this.object[paymentYears - 1].series.length > 1 ?(this.object[paymentYears - 1].series[0].name == 'Annual Healthcare Spend' ? this.object[paymentYears - 1].series[1].value : this.object[paymentYears - 1].series[0].value)  :this.object[paymentYears - 1].series[0].value): this.object[paymentYears].BeginningBalance.toFixed(0);
        console.log('beginningBalance', beginningBalance)
        console.log('phaseOnePercent', phaseOnePercent);
        console.log('freqFactor', freqFactor);
        var pay = Math.ceil(Math.abs(beginningBalance * (phaseOnePercent / freqFactor) / 
          ((Math.pow(1 + (phaseOnePercent / freqFactor), (paymentYears * freqFactor + 1))) - (1 + phaseOnePercent / freqFactor))));
        console.log('pay', pay);

        payment = pay * ((freqFactor > 1) ? paymentYears * 52 : paymentYears);
        this.value = pay;//payment / paymentYears;

        this.passedInitialLoad = true;
      }      
    }

    if(this.passedInitialLoad){
      this.adjustStartInvestment.emit({
        //what to return to SS Illustraiton page here
        selectedBalance: this.value,
        isWeekly: (freqFactor > 1),
        selectedDropDownIndex: this.selectedIndex
      });
    }

    return payment;
  }

}
